export default "__VITE_ASSET__9261cd01__"